/* eslint-disable no-control-regex */

/* eslint-disable no-useless-escape */
import { isFirefox } from 'react-device-detect';
import isNumeric from 'validator/es/lib/isNumeric';
import isAlpha from 'validator/lib/isAlpha';
import isAlphanumeric from 'validator/lib/isAlphanumeric';
import isEmail from 'validator/lib/isEmail';
import { t } from 'i18next';

export const isEmpty = (data: string) => {
  return data === '';
};
export const isNullable = (data: any, config?: { includeEmpty?: boolean }) => {
  const condition: any[] = [null, undefined];
  if (config?.includeEmpty) {
    condition.push('');
  }
  return condition.includes(data);
};

export const isIOS = () => {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform,
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document) ||
    /iPad|iPhone|iPod|iPad Simulator|iPhone Simulator|iPod Simulator/.test(navigator.userAgent)
  );
};

export const isOdd = (number: number) => Math.abs(number) % 2 === 1;
export const isEven = (number: number) => number % 2 === 0;

export const isDollar = (number: number | string) => {
  const regex = /^-?[0-9]\d*((\.\d{0,2})?)$/;
  return regex.test(number.toString());
};

export const hasWhiteSpace = (value: string) => {
  const regex = /\s/;
  return regex.test(value);
};

export const isSingaporeIdentityId = (ic: string) => {
  let icArray = new Array(9);
  for (let i = 0; i < 9; i++) {
    icArray[i] = ic.charAt(i);
  }
  icArray[1] *= 2;
  icArray[2] *= 7;
  icArray[3] *= 6;
  icArray[4] *= 5;
  icArray[5] *= 4;
  icArray[6] *= 3;
  icArray[7] *= 2;
  let weight = 0;
  for (let i = 1; i < 8; i++) {
    weight += parseInt(icArray[i], 10);
  }
  const offset = icArray[0] === 'T' || icArray[0] === 'G' ? 4 : icArray[0] === 'M' ? 3 : 0;
  let temp = (offset + weight) % 11;
  if (icArray[0] === 'M') temp = 10 - temp;
  const st = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A'];
  const fg = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K'];
  const m = ['K', 'L', 'J', 'N', 'P', 'Q', 'R', 'T', 'U', 'W', 'X'];
  let theAlpha;
  if (icArray[0] === 'S' || icArray[0] === 'T') theAlpha = st[temp];
  else if (icArray[0] === 'F' || icArray[0] === 'G') theAlpha = fg[temp];
  else if (icArray[0] === 'M') theAlpha = m[temp];
  return icArray[8] === theAlpha;
};

export const isFIN = (value: string) => {
  const regex = /^[FGM]\d{7}[A-Z]$/i;
  return regex.test(value);
};
export const isNRIC = (value: string) => {
  const regex = /^[ST]\d{7}[A-Z]$/i;
  return regex.test(value);
};

export const isAlphaAndSpace = (value: string) => {
  const regex = /^[a-zA-Z\s]*$/;
  return regex.test(value);
};

export const isNotSupportBackdropFilter = isFirefox;

// export const userNameRegex =
//   /^[a-zàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ ,-/'@]+$/gi;
export const userNameRegex =
  /^[a-záàảãạăắằẳẵặâấầẩẫậđéèẻẽẹêếềểễệíìỉĩịóòỏõọôốồổỗộơớờởỡợúùủũụưứừửữựýỳỷỹỵáàảãạăắằẳẵặâấầẩẫậđéèẻẽẹêếềểễệíìỉĩịóòỏõọôốồổỗộơớờởỡợúùủũụưứừửữựýỳỷỹỵ ,-/'@]+$/gi;

export const companyNameRegex =
  /^[a-záàảãạăắằẳẵặâấầẩẫậđéèẻẽẹêếềểễệíìỉĩịóòỏõọôốồổỗộơớờởỡợúùủũụưứừửữựýỳỷỹỵáàảãạăắằẳẵặâấầẩẫậđéèẻẽẹêếềểễệíìỉĩịóòỏõọôốồổỗộơớờởỡợúùủũụưứừửữựýỳỷỹỵ ,-/'@()\d]+$/gi;

export const isEmailValid = (email: string) => {
  if (!email) return false;

  if (!isEmail(email)) return false;

  return true;
};

export { isNumeric, isAlphanumeric, isAlpha };

export function getValidationErrorMessage(error: any): string {
  const isValidationError =
    error.description && Object.values(error.description).length > 0;

  if (isValidationError) {
    return (Object.values(error.description).flat() as string[])
      .map((msg: string) => `• ${msg}`)
      .join('\n');
  }

  return error.message || t('message.actionFailed');
}
